import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomGenericLinkComponent, SafeUrlPipe } from '@sdvor/shared/ui';
import { MediaModule } from '@spartacus/storefront';
import { ChatLinkComponent } from './chat-link.component';

@NgModule({
  declarations: [ChatLinkComponent],
  exports: [ChatLinkComponent],
  imports: [AsyncPipe, NgIf, MediaModule, NgbTooltipModule, SafeUrlPipe, CustomGenericLinkComponent],
})
export class ChatLinkComponentModule {}
